import { DocumentDataInformation } from 'partner360/components/QBR/components/qbrDocumentDetails/components/qbrDocumentDetailsStepRender/components/dataValidityPanel/components/documentDataInformation/DocumentDataInformation'
import { ReportIssue } from 'partner360/components/QBR/shared/reportIssue/ReportIssue'

import styles from './DataValidityPanel.module.scss'

export const DataValidityPanel = () => {
  return (
    <div className={styles.root}>
      <DocumentDataInformation />
      <ReportIssue />
    </div>
  )
}
